export default __webpack_public_path__ + "static/media/marin.006d7bba.png";